export const ACCOUNT         = 'account'
export const ALMOST          = 'almost'
export const BROWSE          = 'browse'
export const CONFIRM         = 'confirm'
export const GENRE           = 'genre'
export const HOME            = 'home'
export const LOGIN           = 'login'
export const NOTFOUND        = 'notfound'
export const SIGNUP          = 'signup'
export const TITLE           = 'title'
export const WATCH           = 'watch'
export const FORGOT_PASSWORD = 'forgot'


// WEBPACK FOOTER //
// ./src/common/constants/html-tag-class-names.js